import { WebSocketClient } from "@infrastructure/clients/ws/clients/base/websocket.client";

export class NotificationsWebSocketClient extends WebSocketClient {
  wsBaseUrl = "wss://api.phodo.ru";

  async connectToNotifications(): Promise<void> {
    await this.connect("/ws/notifications");
  }

  subscribeToNotifications(onMessage: (data: any) => void, onError?: (error: Error) => void): () => void {
    return this.subscribe("notifications", {
      onMessage,
      onError,
      reconnect: true,
      reconnectDelay: 1000,
      maxReconnectAttempts: 5,
    });
  }
}

